import {
  TRANSFER_NOW,
  TRANSFER_RECURRING_MONTHLY,
  DEFAULT_TRANSACTION_PURPOSE,
  DEFAULT_SOURCE_OF_FUND,
  DEFAULT_BENEFICIARY_TYPE,
  DEFAULT_BENEFICIARY_CITIZEN_STATUS,
  DEFAULT_SENDER_ACCOUNT,
  FAVOURITE_DEFAULT_LIMIT,
} from './transaction';
import { CURRENCY_IDR } from './common';

// initial value for Transfer input fields
export const TRANSFER_FORM_INPUT = {
  accountNumber: '',
  transferAmount: '',
  currency: '',
  transferDate: new Date(),
  transferEndDate: '',
  debitDate: '',
  isRecurring: false,
  isToday: true,
  transferMode: TRANSFER_NOW,
  transferFrequency: TRANSFER_RECURRING_MONTHLY,
  beneficiaryName: '',
  sourceOfFund: DEFAULT_SOURCE_OF_FUND,
  transactionPurpose: DEFAULT_TRANSACTION_PURPOSE,
  beneficiaryType: DEFAULT_BENEFICIARY_TYPE,
  beneficiaryCitizenStatus: DEFAULT_BENEFICIARY_CITIZEN_STATUS,
  message: '',
  beneficiaryEmail: '',
  isError: false,
  errorMessage: '',
  inlineErrorMessage: '',
  validField: {},
  isValid: false,
  transactionCharges: '',
  beneficiaryBankName: '',
  beneficiaryBankOID: '',
  beneficiaryBankSwiftCode: '',
  beneficiaryBankAddress1: '',
  beneficiaryBankAddress2: '',
  beneficiaryBankCountry: '',
  beneficiaryAddressStreet: '',
  beneficiaryAddressOther: '',
  beneficiaryAddressCountry: '',
  beneficiaryID: '',
  beneficiaryDateOfBirth: '',
  // swift LLD form. {} because it returns {key,label}
  lldIdentityStatus: {},
  lldCitizenship: {},
  lldBeneficiary: {},
  lldRelationship: {},
  lldPurpose: {},
  lldDescription: {},
  lldMessage: '',
  bankCode: '',
};

export const PAYMENT_FORM_INPUT = {
  customerNumber: '',
  paymentFrom: DEFAULT_SENDER_ACCOUNT,
  creditCardNumber: '',
  creditCardHolderName: '',
  creditCardName: '',
  creditCardExpiredDate: '',
  selectedBiller: {},
  selectedPayee: {},
  billerDetail: {},
  creditCardIssuer: '',
  creditCardHolder: '',
  paymentOption: '',
  paymentAmount: '',
  creditCardType: '',
  mobileNumber: '',
  message: '',
  currency: '',
};

export const PURCHASE_FORM_INPUT = {
  customerNumber: '',
  purchaseFrom: DEFAULT_SENDER_ACCOUNT,
  paymentCode: '',
  selectedBiller: {},
  billerDetail: {},
  purchaseAmount: '',
  mobilePrefix: '',
  mobileNumber: '',
};

export const FAVOURITE_TRANSFER_INPUT = {
  favouriteTransaction: false,
  favouriteIndex: null,
  favouriteTransferType: '',
  accountHolderName: '',
  toAccountHolderName: '',
  accountNickname: '',
  toAccountNo: '',
  bankName: '',
  emailAddress: '',
  payeeCode: '',
  payeeName: '',
  bankCode: '',
  accountLimit: '',
  currencyCode: CURRENCY_IDR,
  bankSwiftCode: '',
  bankAddress1: '',
  bankAddress2: '',
  bankCountryName: '',
  address1: '',
  address2: '',
  address3: '',
  isFavouriteTransfer: false,
};

export const FAVOURITE_PAYMENT_INPUT = {
  favouritePaymentType: '',
  isFavouritePayment: false,
  isDeleteFavourite: false,
  isEditFavourite: false,
  isAddNewFavourite: false,
  nickname: '',
  biller: '',
  payeeName: '',
  customerNumber: '',
  billerType: '',
  payeeType: '',
  accountNo: '',
  accountNickname: '',
  mobileNumber: '',
  cardType: '',
  creditCardNumber: '',
  cardTypeDisplay: '',
  creditCardNoDisplay: '',
  cardHolderName: '',
  issuingBank: '',
};

export const FAVOURITE_PURCHASE_INPUT = {
  isEditFavourite: false,
  isDeleteFavourite: false,
  isAddNewFavourite: false,
  favouritePurchaseType: '',
  isFavouritePurchase: false,
  nickname: '',
  customerNumber: '',
  mobileNoDisplay: '',
  payeeName: '',
  mobileNo: '',
  mobilePrefix: '',
  favouriteBillerName: '',
  areaCode: '',
};

export const ADD_INBOX_INPUT = {
  subjectId: '',
  message: '',
  isRecurring: false,
};

export const REPLY_INBOX_INPUT = {
  message: '',
  isRecurring: false,
};
